import { render, staticRenderFns } from "./djggg.vue?vue&type=template&id=bf7e9aac&scoped=true"
import script from "./djggg.vue?vue&type=script&lang=js"
export * from "./djggg.vue?vue&type=script&lang=js"
import style0 from "./djggg.vue?vue&type=style&index=0&id=bf7e9aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7e9aac",
  null
  
)

export default component.exports